import { render, staticRenderFns } from "./AdminMorelist.vue?vue&type=template&id=7fffbf62&"
import script from "./AdminMorelist.vue?vue&type=script&lang=js&"
export * from "./AdminMorelist.vue?vue&type=script&lang=js&"
import style0 from "./AdminMorelist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports